import React from 'react';

const fmt = (v) => (v === null || v === undefined || v === '' ? '—' : String(v));

const ORDEM_COLUNAS = [
  ['numero', 'Nº da ordem'],
  ['ordemOriginal', 'Ordem original'],
  ['tipo', 'Tipo'],
  ['canal', 'Canal'],
  ['status', 'Status'],
  ['perfilCobranca', 'Perfil de cobrança'],
  ['equipeVendas', 'Equipe de vendas'],
  ['protocolo', 'Protocolo'],
  ['criadoPor', 'Criado por'],
  ['criadoEm', 'Criado em'],
  ['atualizadoPor', 'Atualizado por'],
  ['atualizadoEm', 'Atualizado em'],
  ['enviadoEm', 'Enviado em'],
  ['geraBa', 'Gera BA'],
  ['integrationId', 'Id de integração']
];

const mesmaOrdem = (a, b) =>
  String(a || '').toUpperCase() === String(b || '').toUpperCase();

function TabelaOrdensConta({ ordens, ordemPedida }) {
  if (!Array.isArray(ordens)) return null;
  const pedidaNaLista = ordens.some((o) => mesmaOrdem(o.numero, ordemPedida));

  return (
    <>
      <div className="ispjp-section-title">Ordens da conta ({ordens.length})</div>
      {ordens.length === 0 ? (
        <p className="ispjp-info">A tabela de ordens desta conta está vazia.</p>
      ) : (
        <>
          {!pedidaNaLista && ordemPedida ? (
            <p className="ispjp-info">
              A ordem {ordemPedida} não está nesta conta. O número pode ter sido
              substituído — escolha uma das ordens da tabela.
            </p>
          ) : (
            <p className="ispjp-info">
              Todas as ordens do Resumo da conta. A linha destacada é o número que você consultou.
            </p>
          )}
          <div className="ispjp-table-wrap">
            <table className="ispjp-table">
              <thead>
                <tr>
                  {ORDEM_COLUNAS.map(([, label]) => (
                    <th key={label}>{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ordens.map((o, i) => {
                  const atual = mesmaOrdem(o.numero, ordemPedida);
                  return (
                    <tr
                      key={`${o.numero || 'ordem'}-${i}`}
                      className={atual ? 'ispjp-ordem-atual' : undefined}
                    >
                      {ORDEM_COLUNAS.map(([key]) => (
                        <td key={key} className={key === 'numero' ? 'ispjp-nowrap' : undefined}>
                          {key === 'numero' && atual ? (
                            <>
                              <strong>{fmt(o.numero)}</strong>
                              <div className="ispjp-ordem-tag">Nº consultado</div>
                            </>
                          ) : (
                            fmt(o[key])
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}

export default TabelaOrdensConta;
